import React from "react";
import ProjectList from "./ProjectList";

const CompletedProjects = () => {
    return <ProjectList status="completed" title="All Projects" />;
};

export default CompletedProjects;
